
function init_settings(Vue) {
  let settings = {
    //timeout:99999 // Tää on hyvä tyylien säätämisessä
    // Tähän voi määritellä Travellerin UI:ssa käytössä olevia asetuksia jotka eroais 
    // notifyjs:n defaulteista. 
  }
  Vue.prototype.$notifications.setOptions(settings);
}


// Save tilanne tulis hoitaa eri komponentin kautta. olkoon nyt kuitenkin täällä
// kun on kerran tehty
function traveller_save() {this.$notify({title: this.$t('notify.saving'), type:'info', timeout: 1000});}
function traveller_saved() { this.$notify({title: this.$t('notify.saved'), type:'success'});}
function traveller_save_error() { this.$notify({title: this.$t('notify.saving_failed'), type:'danger'});}

function traveller_remove() {this.$notify({title: this.$t('notify.deleting'), type:'info'});}
function traveller_removed() { this.$notify({title: this.$t('notify.deleted'), type:'success'});}
function traveller_remove_error() { this.$notify({title: this.$t('notify.deleting_failed'), type:'danger'});}

function traveller_get_data_error() { this.$notify({title: this.$t('notify.data_retrieve_error'), type:'danger'});}

import VueNotify from 'vue-notifyjs'
import '@/plugins/travellernotify.css'

export default {
  install (Vue) {
    Vue.use(VueNotify)
    init_settings(Vue);
    Vue.prototype.$travellerSave = traveller_save;
    Vue.prototype.$travellerSaved = traveller_saved;
    Vue.prototype.$travellerSaveError = traveller_save_error;

    Vue.prototype.$travellerRemove = traveller_remove;
    Vue.prototype.$travellerRemoved = traveller_removed;
    Vue.prototype.$travellerRemoveError = traveller_remove_error;

    Vue.prototype.$travellerGetDataError = traveller_get_data_error;
  }
}
